export enum RequerimientoEstados {
  NUEVO = 0,
  ABIERTO = 1,
  ESPERANDO_USUARIO = 10,
  TERMINADO = 98,
  ANULADO = 99
}